<template>
  <div>
    <RouterView />
    <!-- 使用通知组件 -->
    <NotificationToast ref="notificationRef" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { RouterView, useRouter,useRoute } from "vue-router";
import { setUserRouteParams } from "@/utils/routeParams.ts";
import { getAllDictData } from "@/utils";
import NotificationToast from "@/components/NotificationToast/NotificationToast.vue";
import { setNotificationInstance, notification } from "@/components/NotificationToast/notification";
import request from "@/utils/request";

const router = useRouter();
const route = useRoute();
// 引用通知组件实例
const notificationRef = ref<InstanceType<typeof NotificationToast> | null>(null);
const notShowInforBox =  ['/login','/register','/cloudPhone','/reset',
'/getDevice','/workPlace','/exchangeCode','/allocateDevice','/configSkuStock','/userDetail']




// 组件挂载时设置通知实例
onMounted(async () => {
  if (notificationRef.value) {
    // 正确设置通知实例，通过组件暴露的方法
    setNotificationInstance({
      showNotification: notificationRef.value.showNotification,
      removeNotification: notificationRef.value.removeNotification,
      clearAll: notificationRef.value.clearAll
    });
  }
  
  // 应用初始化
  setUserRouteParams([]);
  await getAllDictData(); // 在App.vue中使用await等待完成

  // 如果路由为cloudPhone 
  if(!notShowInforBox.some(item => route.path.includes(item))){
    await getFeedbackHandlingState();
  }
})

const getFeedbackHandlingState = async () => {
  try {                                 
    const res: any = await request.post('/content/adviceFeedback/findHandlingState');
    if (res.code === 200) {
      const data = res.data;
      if (data.length > 0) {
        notification.info('', {
          title: '新消息通知',
          htmlMessage: `您有 <span style="color: #f56c6c;">${data.length}</span> 条反馈事项待处理，最近一条为${data[0].sysCreateTime}产生`,
          duration: 10000,
          autoCloseOnClick: true,
          onClick: () => {
            router.push('/userMgt/feedBackPage?status=0');
          }
        });
      }
    }
  } catch (error) {
    console.error('获取反馈处理状态失败:', error);
  }
};

// 组件卸载时清理
onUnmounted(() => {
  setNotificationInstance(null);
});
</script>

<style>
/* 全局样式 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* 全局修改 el-table 的滚动条 */
.el-scrollbar__bar.is-horizontal {
  height: 10px!important; /* 水平滚动条高度 */
}

.el-scrollbar__bar.is-vertical{
  width: 10px!important; /* 水平滚动条高度 */
}

.el-dropdown .el-button:focus-visible {
  outline: none!important;
}
</style>